module.exports = __webpack_public_path__ + "static/media/inventory.9c259ed9.svg";